module.exports = __webpack_public_path__ + "img/team.95931acd.svg";